export const getDiseaseTranslationKey = (diseaseCode, subDiseaseCode = null) => {
  const parts = [
    'quest_selector.cancer_types',
    diseaseCode?.toLowerCase().trim() ?? '',
    subDiseaseCode?.toLowerCase().trim() ?? '',
  ];

  return parts.filter(Boolean).join('.');
};
